import template from './template.html'

angular
  .module('contabilidad.polizasexternas')
  .component('contabilidadPolizasexternasLauncher', {
    template,
  })




// WEBPACK FOOTER //
// ./src/contabilidad/polizasexternas/components/launcher/component.js